export const uploadConfig = {
  Bucket: "upload-attch-1256082024",
  Region: "ap-beijing",
  SecretId: "AKIDY1KYbXeO9j9OJ8sKg8R4iEYkcN0UeslH",
  SecretKey: "iWEpDTGxXzFJB0e5KNRfkDj9MNCqdJqH",
  appName: "jf",
};
